export default __webpack_public_path__ + "static/media/kitchen3-afterG-768w.b23e7ac9.webp";